module.exports = __webpack_public_path__ + "img/suLogo.98198b74.png";